import { render } from "./VacationHistory.vue?vue&type=template&id=793090fb&ts=true"
import script from "./VacationHistory.vue?vue&type=script&lang=ts"
export * from "./VacationHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__